import React from "react";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = ({ isActive, ...rest }) => {
  return isActive ? (
    <svg xmlns="http://www.w3.org/2000/svg" {...rest} width="25" height="25" viewBox="0 0 25 25" fill="none">
      <path
        d="M2.87781 12.3877C2.87781 7.67365 2.87781 5.31663 4.34227 3.85216C5.80674 2.3877 8.16376 2.3877 12.8778 2.3877C17.5919 2.3877 19.9489 2.3877 21.4133 3.85216C22.8778 5.31663 22.8778 7.67365 22.8778 12.3877C22.8778 17.1017 22.8778 19.4588 21.4133 20.9232C19.9489 22.3877 17.5919 22.3877 12.8778 22.3877C8.16376 22.3877 5.80674 22.3877 4.34227 20.9232C2.87781 19.4588 2.87781 17.1017 2.87781 12.3877Z"
        stroke="white"
        strokeWidth="1.5"
      />
      <path d="M6.87756 7.38721L6.87756 17.3872" stroke="#F59C53" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M17.3776 9.8877L18.8776 8.3877" stroke="#F59C53" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M10.8773 16.3872L12.3773 14.8872" stroke="#F59C53" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M12.3773 9.8877L10.8773 8.3877" stroke="#F59C53" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M18.8776 16.3872L17.3776 14.8872" stroke="#F59C53" strokeWidth="1.5" strokeLinecap="round" />
      <path
        d="M11.8778 12.3877C11.8778 10.7308 13.221 9.3877 14.8778 9.3877C16.5347 9.3877 17.8778 10.7308 17.8778 12.3877C17.8778 14.0445 16.5347 15.3877 14.8778 15.3877C13.221 15.3877 11.8778 14.0445 11.8778 12.3877Z"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  ) : (
    <svg xmlns="http://www.w3.org/2000/svg" {...rest} width="25" height="25" viewBox="0 0 25 25" fill="none">
      <path
        d="M2.87769 12.898C2.87769 8.1839 2.87769 5.82688 4.34215 4.36242C5.80662 2.89795 8.16364 2.89795 12.8777 2.89795C17.5917 2.89795 19.9488 2.89795 21.4132 4.36242C22.8777 5.82688 22.8777 8.1839 22.8777 12.898C22.8777 17.612 22.8777 19.969 21.4132 21.4335C19.9488 22.898 17.5917 22.898 12.8777 22.898C8.16364 22.898 5.80662 22.898 4.34215 21.4335C2.87769 19.969 2.87769 17.612 2.87769 12.898Z"
        stroke="white"
        strokeWidth="1.5"
      />
      <path d="M6.87744 7.89746L6.87744 17.8975" stroke="#888888" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M17.3774 10.3979L18.8774 8.89795" stroke="#888888" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M10.8772 16.8975L12.3772 15.3975" stroke="#888888" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M12.3772 10.3979L10.8772 8.89795" stroke="#888888" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M18.8774 16.8975L17.3774 15.3975" stroke="#888888" strokeWidth="1.5" strokeLinecap="round" />
      <path
        d="M11.8777 12.8979C11.8777 11.2411 13.2208 9.89795 14.8777 9.89795C16.5345 9.89795 17.8777 11.2411 17.8777 12.8979C17.8777 14.5548 16.5345 15.8979 14.8777 15.8979C13.2208 15.8979 11.8777 14.5548 11.8777 12.8979Z"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default Icon;
